import { TempPill, StatusPill } from "./Pills";

export default function DashboardLeadsTable({ leads, loading, onOpen }) {
  return (
    <div className="overflow-x-auto">
      <table className="w-full text-sm" data-testid="leads-table">
        <thead>
          <tr className="border-b border-[#E0E4E2] text-left text-[11px] font-bold uppercase tracking-[0.15em] text-[#5C6B68]">
            <th className="px-4 py-3">Name</th>
            <th className="px-4 py-3">Temp</th>
            <th className="px-4 py-3">Contact</th>
            <th className="px-4 py-3">State / City</th>
            <th className="px-4 py-3">Accident</th>
            <th className="px-4 py-3">Submitted</th>
            <th className="px-4 py-3">Status</th>
            <th className="px-4 py-3"></th>
          </tr>
        </thead>
        <tbody>
          {loading && (
            <tr><td colSpan={8} className="px-4 py-12 text-center text-[#5C6B68]">Loading…</td></tr>
          )}
          {!loading && leads.length === 0 && (
            <tr><td colSpan={8} className="px-4 py-12 text-center text-[#5C6B68]">No leads match the current filters.</td></tr>
          )}
          {!loading && leads.map((l) => (
            <tr
              key={l.id}
              className="cursor-pointer border-b border-[#E0E4E2] last:border-0 hover:bg-[#FDFBF7]"
              data-testid={`lead-row-${l.id}`}
              onClick={(e) => {
                // Don't open the dialog if the user clicked an actual link (mailto/tel) or button
                if (e.target.closest("a,button")) return;
                onOpen(l);
              }}
            >
              <td className="px-4 py-3 font-bold text-[#0B1317]">{l.full_name}</td>
              <td className="px-4 py-3"><TempPill temperature={l.temperature} score={l.temperature_score} /></td>
              <td className="px-4 py-3 text-[#0B1317]">
                <div className="flex flex-col gap-0.5">
                  <a href={`mailto:${l.email}`} className="hover:text-[#E85D04]">{l.email}</a>
                  <a href={`tel:${l.phone}`} className="text-[#5C6B68] hover:text-[#E85D04]">{l.phone}</a>
                </div>
              </td>
              <td className="px-4 py-3 text-[#0B1317]">
                <div className="font-semibold">{l.state}</div>
                <div className="text-xs text-[#5C6B68]">{l.city || "—"}</div>
              </td>
              <td className="px-4 py-3 text-[#0B1317]">
                <div>{l.accident_type || "—"}</div>
                <div className="text-xs text-[#5C6B68]">{l.accident_date || ""}</div>
              </td>
              <td className="px-4 py-3 text-[#5C6B68]">{new Date(l.created_at).toLocaleString()}</td>
              <td className="px-4 py-3"><StatusPill status={l.status} /></td>
              <td className="px-4 py-3 text-right">
                <button onClick={() => onOpen(l)} className="text-sm font-bold text-[#11322A] hover:text-[#E85D04]" data-testid={`lead-open-${l.id}`}>Open</button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
